export default {
  path: '/versionLog',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/versionLog/home',
  children: [
    {
      path: 'index',
      name: 'versionLog_index',
      component: () => import('./index')
    },
  ]
}



// WEBPACK FOOTER //
// ./src/pages/versionLog/router_versionLog.js